<div>
  <p>
    {{ 'ACTIONS.STATUS' | translate }}
  </p>
  <div class="current-status">
    <app-action
      [disableToggleClick]=true
      [terminal]="terminal"
    ></app-action>
  </div>
  <div *ngFor="let action of filteredActions">
    <app-action
      (preventToggleClick)="onPreventToggleClick($event)"
      [action]="action"
      [disableToggleClick]="disableToggleClick"
      [terminal]="terminal"
    ></app-action>
  </div>
</div>
